/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from "react";
import {
  Row,
  Col,
  Card,
  Avatar,
  Typography,
  Popconfirm,
  message,
  Button,
  Divider,
  Collapse,
  Image,
  Modal,
} from "antd";
import { useState, useEffect, lazy, Suspense, useRef } from "react";
import { useNavigate } from "react-router-dom";
import GETDetalleOrdenREU from "../../../helpers/ordenes/GETDetalleOrdenREU";
import GETCodigoBarra from "../../../helpers/auditoria/GETCodigoBarra";
import PUTSetReubicacion from "../../../helpers/ordenes/PUTSetReubicacion";
import PUTConfirmarReuEgreso from "../../../helpers/ordenes/PUTConfirmarReuEgreso";
import PUTConfirmarReuIngreso from "../../../helpers/ordenes/PUTConfirmarReuIngreso";
import PUTCompletarReuIngreso from "../../../helpers/ordenes/PUTCompletarReuIngreso";
import PUTCompletarReuEgreso from "../../../helpers/ordenes/PUTCompletarReuEgreso";
import { getCardStyle } from "../../../utils/getCardStyle";
import PUTCompletarOma from "../../../helpers/ordenes/PUTCompletarOma";
import {
  ImportOutlined,
  ExportOutlined,
  LockOutlined,
  UnlockOutlined,
} from "@ant-design/icons";
import { formatEtiquetaUbicacion } from "../../../utils/formatEtiquetaUbicacion";
import PUTConfirmarReuEgresoPaletsManual from "../../../helpers/ordenes/PUTConfirmarReuEgresoPaletsManual";
import PUTConfirmarReuIngresoPaletsManual from "../../../helpers/ordenes/PUTConfirmarReuIngresoPaletsManual";
import Loader from "../../../components/loader/Loader";
import "../../../index.css";
import PUTAbrirPalet from "../../../helpers/ordenes/PUTAbrirPalet";
import GETStockUbicacionArticulo from "../../../helpers/ordenes/GETStockUbicacionArticulo";
import ModalStockVLX from "../modalStockVLX/ModalStockVLS";
import { useAppVersionContext } from "../../../AppVersionContext";

const ModalTecladoCantidad = lazy(
  () => import("../../../components/modalTecladoCantidad/ModalTecladoCantidad"),
);

const { Text } = Typography;

// === ArticuloCard ===
const ArticuloCard = React.memo(
  ({ item, darkMode, ordenActiva, reuActual, onEdit }) => {
    const codigo = item.codigo ?? item.sku ?? null;

    const ctdpar = item.articulologico_ctdpar ?? item.ctdpar ?? 0;

    const nropar = item.articuloparte_numeroparte ?? item.nropar ?? null;

    return (
      <Card
        hoverable
        styles={{ body: { padding: 16 } }}
        style={{
          ...getCardStyle(darkMode),
          height: "100%",
          flex: 1,
          backgroundColor: item?.afecta !== "0" ? "#c8e6c9" : "#ffebee",
          transition: "background-color 0.3s ease",
        }}
      >
        <Row align="top" justify="space-between">
          <div style={{ flex: 1 }}>
            {(codigo || nropar) && (
              <Text
                strong
                style={{
                  fontSize: "20px",
                  color: "#000",
                  marginBottom: "4px",
                  display: "block",
                }}
              >
                {codigo ?? "-"}
                {ctdpar > 1 && nropar
                  ? `-${String(nropar).padStart(2, "0")}`
                  : ""}
              </Text>
            )}
            <Text
              type="secondary"
              style={{ fontSize: "16px", color: "#000", display: "block" }}
            >
              {item.nombre}
            </Text>
            <Text strong style={{ display: "block", color: "#000" }}>
              {item?.valcar}
            </Text>
            <Text
              type="secondary"
              style={{ fontSize: "16px", color: "#000", display: "block" }}
            >
              {item.modelo}
            </Text>
          </div>

          <div style={{ textAlign: "right", minWidth: 120 }}>
            <Text
              strong
              style={{
                fontSize: "20px",
                marginBottom: "8px",
                display: "block",
                color: "#000",
              }}
            >
              {item.etique}
            </Text>
            <Avatar
              src="/assets/producto.png"
              size={60}
              style={{ backgroundColor: "#8f9ee0" }}
            />
          </div>
        </Row>

        <Row justify="space-between" align="middle" style={{ marginTop: 12 }}>
          <Col>
            {ordenActiva &&
              item.cantid >= 1 &&
              ((item.afecta === "0" && reuActual.accion === "1") ||
                (item.afecta === "2" && reuActual.accion === "2")) && (
                <Image
                  className="custom-icon"
                  src="/icons/keyboard.png"
                  preview={false}
                  style={{
                    width: 40,
                    cursor: "pointer",
                    transition: "color 0.2s ease",
                    marginTop: "8px",
                  }}
                  onClick={() => onEdit(item)}
                />
              )}
          </Col>
          <Col>
            <Text
              type="secondary"
              strong
              style={{ fontSize: "20px", color: "#000" }}
            >
              {Math.round(item.confir)} Unid.
            </Text>
          </Col>
        </Row>
      </Card>
    );
  },
);

// === PaletCard ===
const PaletCard = React.memo(
  ({ item, darkMode, ordenActiva, reuActual, onEdit, onLongPressUnlock }) => {
    const longPressTimer = useRef(null);

    const startLongPress = () => {
      longPressTimer.current = setTimeout(() => {
        if (item?.pltcer) {
          onLongPressUnlock?.(item);
        }
      }, 500);
    };

    const clearLongPress = () => {
      if (longPressTimer.current) {
        clearTimeout(longPressTimer.current);
        longPressTimer.current = null;
      }
    };

    return (
      <Card
        hoverable
        styles={{ body: { padding: 16 } }}
        style={{
          ...getCardStyle(darkMode),
          height: "100%",
          flex: 1,
          backgroundColor: item?.afecta !== "0" ? "#c8e6c9" : "#ffebee",
          transition: "background-color 0.3s ease",
        }}
      >
        <Row align="top" justify="space-between">
          <div style={{ flex: 1 }}>
            <Text
              strong
              style={{
                fontSize: "20px",
                color: "#000",
                marginBottom: "4px",
                display: "block",
              }}
            >
              #{item.idpale}
            </Text>

            <Text
              type="secondary"
              strong
              style={{ fontSize: "20px", color: "#000" }}
            >
              {item?.nombre}
            </Text>
          </div>

          <div style={{ textAlign: "right", minWidth: 120 }}>
            <Text
              strong
              style={{
                fontSize: "20px",
                marginBottom: "8px",
                display: "block",
                color: "#000",
              }}
            >
              {item.etique}
            </Text>
            <Avatar
              src="https://wms.oscarbarbieri.com/assets/palet.png  "
              size={60}
              style={{ backgroundColor: "#d5c279" }}
            />
          </div>
        </Row>

        <Row justify="space-between" align="middle" style={{ marginTop: 12 }}>
          <Col>
            {ordenActiva &&
              item?.afecta !== "0" &&
              onLongPressUnlock != null && ( // De esta manera, cómo invoco PaletCard de dos lugares, si el callback esta null, interpreto que no debo mostrar ni permitir usar el candado (funcionalidad de apertura de palet)
                <div
                  style={{ cursor: "pointer", display: "inline-block" }}
                  onMouseDown={startLongPress}
                  onMouseUp={clearLongPress}
                  onMouseLeave={clearLongPress}
                  onTouchStart={startLongPress}
                  onTouchEnd={clearLongPress}
                  onClick={(e) => e.stopPropagation()}
                >
                  {item?.pltcer ? (
                    <LockOutlined
                      style={{ fontSize: 27, color: "#000" }}
                      className="custom-icon"
                    />
                  ) : (
                    <UnlockOutlined
                      style={{ fontSize: 27, color: "#000" }}
                      className="custom-icon"
                    />
                  )}
                </div>
              )}
          </Col>
          <Col>
            <Text
              type="secondary"
              strong
              style={{ fontSize: "20px", color: "#000" }}
            >
              {Math.round(item.confir)} Unid.
            </Text>
          </Col>
        </Row>
      </Card>
    );
  },
);

// Parte fundamental del cuerpo de DetalleReubicacion
const RenderREU = ({
  dataOrden,
  darkMode,
  ordenActiva,
  valorTecladoGlobal,
}) => {
  const navigate = useNavigate();
  const { usaModoLote } = useAppVersionContext();
  const [reuActual, setReuActual] = useState(dataOrden);
  const [loadingNuevaUbi, setLoadingNuevaUbi] = useState(false);
  const [loading, setLoading] = useState(false);
  const [unlockModal, setUnlockModal] = useState({
    visible: false,
    palet: null,
  });

  const [modalVisible, setModalVisible] = useState({
    status: false,
    payload: {},
  });

  const [modalStockVLX, setModalStockVLX] = useState({
    open: false,
    items: [],
    codigoOriginal: null,
    responseCodigo: null,
  });

  const reuActualRef = useRef(dataOrden);

  useEffect(() => {
    reuActualRef.current = reuActual;
  }, [reuActual]);

  const handleLongPressUnlock = (palet) => {
    setUnlockModal({
      visible: true,
      palet,
    });
  };

  const handleConfirmUnlock = async () => {
    const { palet } = unlockModal;

    if (!palet?.idomau || !palet?.idpale) {
      message.error("Datos del palet incompletos");
      setUnlockModal({ visible: false, palet: null });
      return;
    }

    try {
      setLoading(true); // Inicia loading desde el principio

      const response = await PUTAbrirPalet(palet.idomau, palet.idpale);
      setUnlockModal({ visible: false, palet: null });

      if (!response?.data) {
        throw new Error("Respuesta vacía al abrir el palet");
      }

      const { codres, descri } = response.data;

      if (codres !== 0) {
        message.error(descri || "Error al abrir el palet");
      } else {
        // message.success(descri || "Palet abierto correctamente");

        // Recargar los datos de la orden
        const responseReu = await GETDetalleOrdenREU(reuActual?.id);
        if (responseReu?.data) {
          setReuActual(responseReu.data);
        } else {
          console.warn("No se pudo recargar la orden REU");
          // Opcional: mensaje de advertencia
        }
      }
    } catch (error) {
      console.error("Error en handleConfirmUnlock:", error);
      message.error("Error de conexión o interno al procesar la solicitud");
    } finally {
      setLoading(false);
    }
  };

  const handleCancelUnlock = () => {
    setUnlockModal({ visible: false, palet: null });
  };

  const confirmarItemStockVLX = async (item, responseCodigoParam = null) => {
    const responseCodigo = responseCodigoParam || modalStockVLX.responseCodigo;

    if (!item) return;

    const accion = reuActualRef.current?.accion;
    const idubid = reuActualRef.current?.idUbicacionSeleccionada;

    if (!idubid && accion === "2") {
      message.error("Primero debe leer una ubicación");
      return;
    }

    const idpale = item.idpale || item.palet_id || responseCodigo?.idpale;
    const idartp =
      item.idartp || item.articuloparte_id || responseCodigo?.idartp;

    let payloadReubi;

    if (idpale) {
      if (accion === "1") {
        payloadReubi = {
          idomamov: reuActualRef.current?.idOpe,
          idpale,
          cantidad: 1,
          esLecturaCodBarras: true,
        };

        const res = await PUTConfirmarReuEgresoPaletsManual(payloadReubi);

        if (res?.status !== 200) {
          message.error(res?.data?.message || "Error al confirmar palet");
          return;
        }
      } else {
        payloadReubi = {
          idomamov: reuActualRef.current?.idOpe,
          idpale,
          idubid,
          cantidad: 1,
          esLecturaCodBarras: true,
        };

        const res = await PUTConfirmarReuIngresoPaletsManual(payloadReubi);

        if (res?.status !== 200) {
          message.error(res?.data?.message || "Error al confirmar palet");
          return;
        }
      }
    } else if (idartp) {
      payloadReubi = {
        idomamov: reuActualRef.current?.idOpe,
        idartp,
        idubid,
        cantidad: 1,
        esLecturaCodBarras: true,
      };

      const res =
        accion === "1"
          ? await PUTConfirmarReuEgreso(payloadReubi)
          : await PUTConfirmarReuIngreso(payloadReubi);

      if (res?.status !== 200) {
        message.error(res?.data?.message || "Error al confirmar artículo");
        return;
      }
    } else {
      message.error("No se pudo determinar artículo/palet para confirmar");
      return;
    }

    setModalStockVLX({
      open: false,
      items: [],
      codigoOriginal: null,
      responseCodigo: null,
    });

    const fresh = await GETDetalleOrdenREU(reuActualRef.current?.id);
    fresh?.data && setReuActual(fresh.data);
  };

  const handleProcesamientoVLX = async (codigo) => {
    const response = await GETCodigoBarra(codigo, null, false, false);

    if (response?.status !== 200) {
      message.error(response?.data?.message || "Código no válido");
      return true;
    }

    if (response.data?.idtipa !== "04") {
      return false;
    }

    const accion = reuActualRef.current?.accion;

    if (accion === "1") {
      if (!reuActualRef.current?.idUbicacionSeleccionada) {
        message.error("Primero debe leer una ubicación");
        return true;
      }

      const stockResponse = await GETStockUbicacionArticulo(
        reuActualRef.current?.idUbicacionSeleccionada,
        response.data.idartl,
      );

      const items = Array.isArray(stockResponse?.data)
        ? stockResponse.data
        : [];

      if (items.length === 0) {
        message.error(
          "No se encontró stock para este artículo en la ubicación",
        );
        return true;
      }

      if (items.length === 1) {
        await confirmarItemStockVLX(items[0], response.data);
        return true;
      }

      setModalStockVLX({
        open: true,
        items,
        codigoOriginal: codigo,
        responseCodigo: response.data,
      });

      return true;
    }

    if (accion === "2") {
      if (!reuActualRef.current?.idUbicacionSeleccionada) {
        message.error("Primero debe leer una ubicación");
        return true;
      }

      const skuLeido = response.data?.codigo || response.data?.sku || "";

      const normalizarSku = (value) =>
        String(value || "")
          .replace(/-/g, "")
          .trim();

      const pendientesIngreso =
        reuActualRef.current?.ubicacionesREUEmpleadoLogeado?.filter((item) => {
          const mismoIdartl =
            String(item.idartl) === String(response.data.idartl);

          const mismoSku =
            normalizarSku(item.codigo) === normalizarSku(skuLeido) ||
            normalizarSku(item.sku) === normalizarSku(skuLeido);

          return (
            String(item.estado) === "2" &&
            String(item.afecta) === "0" &&
            (mismoIdartl || mismoSku)
          );
        }) || [];

      if (pendientesIngreso.length === 0) {
        message.error("No se encontró un pendiente de ingreso para ese SKU");
        return true;
      }

      if (pendientesIngreso.length === 1) {
        await confirmarItemStockVLX(pendientesIngreso[0], response.data);
        return true;
      }

      setModalStockVLX({
        open: true,
        items: pendientesIngreso,
        codigoOriginal: codigo,
        responseCodigo: response.data,
      });

      return true;
    }

    return true;
  };

  // procesa cualquier código (modal o teclado físico)
  const procesarCodigoEscaneado = useCallback(async (codigo) => {
    if (!codigo || !ordenActiva) return;

    // Para REU: no permitir en estados 1 o 4
    if (dataOrden?.estadoOpe === "1" || dataOrden?.estadoOpe === "4") {
      return;
    }

    try {
      setLoading(true);

      if (usaModoLote === "true") {
        const procesadoVLX = await handleProcesamientoVLX(codigo);

        if (procesadoVLX) {
          return;
        }
      }

      const response = await GETCodigoBarra(codigo);

      if (response?.status === 200) {
        // Si el codigo corresponde a una ubicación
        if (response?.data?.idubid && response?.data?.codres === 1) {
          // ubicación
          setLoadingNuevaUbi(true);
          const responseReu = await PUTSetReubicacion(
            reuActual?.id,
            response?.data?.idubid,
          );

          if (responseReu?.status === 200) {
            // Primero, obtener el estado FRESO después de asignar la ubicación
            const fresh = await GETDetalleOrdenREU(reuActual?.id);
            if (fresh?.data) {
              const nuevaReu = fresh.data;
              setReuActual(nuevaReu);
              // message.success(responseReu?.data?.descri);

              // Solo si estamos en INGRESO
              if (nuevaReu.accion === "2") {
                // Buscar SOLO palets pendientes (con idpale)
                const paletPendiente =
                  nuevaReu.ubicacionesREUEmpleadoLogeado?.find(
                    (x) => x.estado === "2" && x.idpale != null,
                  );

                if (paletPendiente) {
                  try {
                    const payloadReubi = {
                      idomamov: nuevaReu.idOpe,
                      idpale: paletPendiente.idpale,
                      idubid: response.data.idubid, // usamos la ubicación recién escaneada
                      cantidad: 1,
                      esLecturaCodBarras: true,
                    };

                    const res =
                      await PUTConfirmarReuIngresoPaletsManual(payloadReubi);
                    if (res?.status === 200) {
                      // Refrescar nuevamente para reflejar la confirmación
                      const finalFresh = await GETDetalleOrdenREU(nuevaReu.id);
                      if (finalFresh?.data) {
                        setReuActual(finalFresh.data);
                        // message.success("Palet confirmado automáticamente");
                      }
                    } else {
                      message.error(
                        res?.data?.message || "Error al confirmar palet",
                      );
                    }
                  } catch (err) {
                    console.error("Error al confirmar palet:", err);
                    message.error("No se pudo confirmar el palet");
                  }
                }
              }
            }
          } else {
            message.error(responseReu?.data?.message);
          }
          setLoadingNuevaUbi(false);
        } else if (response?.data?.idartp && response?.data?.codres === 0) {
          // articulo
          // Si el codigo corresponde a un articulo
          const payloadReubi = {
            idomamov: reuActual?.idOpe,
            idartp: response?.data?.idartp,
            idubid: reuActualRef.current?.idUbicacionSeleccionada,
            cantidad: 1,
            esLecturaCodBarras: true,
          };

          if (payloadReubi.idubid == null) {
            message.error("Primero debe leer una ubicación");
            return;
          }

          if (reuActualRef.current?.accion === "1") {
            const res = await PUTConfirmarReuEgreso(payloadReubi);

            if (res?.status === 200) {
              const fresh = await GETDetalleOrdenREU(reuActual?.id);
              fresh?.data && setReuActual(fresh.data);
            } else {
              message.error(res?.data?.message);
            }
          } else {
            const res = await PUTConfirmarReuIngreso(payloadReubi);
            if (res?.status === 200) {
              const fresh = await GETDetalleOrdenREU(reuActual?.id);
              fresh?.data && setReuActual(fresh.data);
            } else {
              message.error(res?.data?.message);
            }
          }
        } else if (response?.data?.idpale && response?.data?.codres === 2) {
          // palet

          if (reuActualRef.current?.accion === "1") {
            const payloadReubiEgreso = {
              idomamov: reuActual?.idOpe,
              idpale: response?.data?.idpale,
              // idubid: reuActualRef.current?.idUbicacionSeleccionada ?? undefined, // No hace falta la idubid porque se toma internamente del palet leido
              cantidad: 1,
              esLecturaCodBarras: true,
            };
            const res =
              await PUTConfirmarReuEgresoPaletsManual(payloadReubiEgreso);
            if (res?.status === 200) {
              const fresh = await GETDetalleOrdenREU(reuActual?.id);
              fresh?.data && setReuActual(fresh.data);
            } else {
              message.error(res?.data?.message);
            }
          } else {
            if (!reuActualRef.current?.idUbicacionSeleccionada) {
              message.error("Primero debe leer una ubicación");
              return;
            }
            const payloadReubiIngreso = {
              idomamov: reuActual?.idOpe,
              idpale: response?.data?.idpale,
              idubid:
                reuActualRef.current?.idUbicacionSeleccionada ?? undefined,
              cantidad: 1,
              esLecturaCodBarras: true,
            };

            const res =
              await PUTConfirmarReuIngresoPaletsManual(payloadReubiIngreso);
            if (res?.status === 200) {
              const fresh = await GETDetalleOrdenREU(reuActual?.id);
              fresh?.data && setReuActual(fresh.data);
            } else {
              message.error(res?.data?.message);
            }
          }
        }
      } else {
        message.error(response?.data?.message || "Código no válido");
      }
    } catch (error) {
      console.error("Error al procesar código:", error);
      message.error("Error de conexión al validar el código.");
    } finally {
      setLoading(false);
    }
  });

  useEffect(() => {
    if (valorTecladoGlobal !== null) {
      procesarCodigoEscaneado(valorTecladoGlobal.trim());
    }
  }, [valorTecladoGlobal]);

  const bufferRef = useRef("");

  // Ref para el handler actualizado
  const keyHandlerRef = useRef(null);

  useEffect(() => {
    // Actualizamos el handler interno con el estado más reciente
    keyHandlerRef.current = async (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        const codigo = bufferRef.current.trim();
        bufferRef.current = "";
        await procesarCodigoEscaneado(codigo);
        return;
      }

      if (e.key === "Backspace") {
        bufferRef.current = bufferRef.current.slice(0, -1);
        return;
      }

      if (e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey) {
        const char = e.key === "!" ? "#" : e.key;
        bufferRef.current += char;
      }
    };
  }, [procesarCodigoEscaneado]); // procesarCodigoEscaneado debe ser estable (ver nota abajo)

  // Efecto que registra el listener una sola vez
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (keyHandlerRef.current) {
        keyHandlerRef.current(e);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const reubicados = (reuActual?.ubicacionesREUEmpleadoLogeado || []).filter(
    (item) => item.estado === "3",
  );

  const hayReubicados = reubicados.length > 0;

  const pendientesDeConfirmar =
    reuActual?.ubicacionesREUEmpleadoLogeado?.filter((x) => x.estado === "2");

  const hayPendientesDeConfirmar = pendientesDeConfirmar.length > 1;

  const handlePasarAEgreso = async () => {
    setLoading(true);
    const res = await PUTCompletarReuIngreso(reuActual?.idOpe);
    if (res?.status !== 200) {
      message.error(res?.data?.message);
    } else {
      // message.success(res?.data?.descri);
      const response = await GETDetalleOrdenREU(reuActual?.id);
      if (response?.data) {
        setReuActual(response.data);
      }
    }
    setLoading(false);
  };

  const handlePasarAIngreso = async () => {
    setLoading(true);
    const res = await PUTCompletarReuEgreso(reuActual?.idOpe);
    if (res?.status !== 200) {
      message.error(res?.data?.message);
    } else {
      // message.success(res?.data?.descri);
      const response = await GETDetalleOrdenREU(reuActual?.id);
      if (response?.data) {
        setReuActual(response.data);
      }
    }
    setLoading(false);
  };

  const handleConfirmModal = async (itemActualizado) => {
    const { valorFinal, sku } = itemActualizado;

    let idartp = itemActualizado?.idartp;

    if (usaModoLote !== "true") {
      const skuLimpio = sku.replace(/-/g, "");

      const response = await GETCodigoBarra(skuLimpio);

      if (response?.status !== 200 || !response?.data?.idartp) {
        message.error(
          "El SKU ingresado no es válido. Comuniquesé con sistemas.",
        );
        return;
      }

      idartp = response.data.idartp;
    }

    if (!idartp) {
      message.error("No se pudo determinar el artículo a confirmar.");
      return;
    }

    const payloadReubi = {
      idomamov: reuActual?.idOpe,
      idartp,
      idubid: itemActualizado?.idubid,
      cantidad: valorFinal,
      esLecturaCodBarras: false,
    };

    if (reuActualRef.current?.accion === "1") {
      const res = await PUTConfirmarReuEgreso(payloadReubi);

      if (res?.status !== 200) {
        message.error(res?.data?.message);
        return;
      }
    } else {
      const res = await PUTConfirmarReuIngreso(payloadReubi);

      if (res?.status !== 200) {
        message.error(res?.data?.message);
        return;
      }
    }

    const response = await GETDetalleOrdenREU(reuActual?.id);

    if (response?.data) {
      setReuActual(response.data);
      setModalVisible({ status: false });
    }
  };

  const AccionIcon = ({ accion }) => {
    const esEgreso = accion === "1";

    return (
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: esEgreso ? "#ffebeb" : "#eafff0", // fondos más suaves
          border: `1px solid ${esEgreso ? "#ffccc7" : "#b7eb8f"}`,
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)", // ligera sombra para profundidad
        }}
      >
        {esEgreso ? (
          <ExportOutlined
            style={{
              color: "#d32f2f", // rojo más elegante (Material Red 600)
              fontSize: 19,
            }}
          />
        ) : (
          <ImportOutlined
            style={{
              color: "#2e7d32", // verde más refinado (Material Green 700)
              fontSize: 19,
            }}
          />
        )}
      </div>
    );
  };

  return (
    <>
      <Col
        span={24}
        style={{
          position: "sticky",
          top: -10,
          zIndex: 10,
          padding: 0,
          backgroundColor: darkMode ? "#222" : "#fafafa",
          color: darkMode ? "#fff" : "#000",
          borderRadius: 6,
        }}
      >
        <div className="ubi-wrapper" style={{ alignItems: "baseline" }}>
          <Typography.Title
            level={4}
            className="ubi-text"
            style={{ display: "flex", alignItems: "center", gap: 12 }}
          >
            <AccionIcon accion={reuActual?.accion} />
            <span style={{ alignSelf: "center" }}>|</span>
            {loadingNuevaUbi
              ? "Procesando nueva ubicación..."
              : formatEtiquetaUbicacion(reuActual?.ubicacion)
                ? formatEtiquetaUbicacion(reuActual?.ubicacion)
                : reuActual?.accion === "1"
                  ? "Escanea una ubicación de egreso"
                  : reuActual?.accion === "2"
                    ? "Escanea una ubicación de ingreso"
                    : "No ha escaneado ninguna ubicación"}
          </Typography.Title>
        </div>
      </Col>

      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "transparent",
            zIndex: 9999,
            pointerEvents: "none",
          }}
        >
          <Loader />
        </div>
      )}

      {/* Artículos en estado "2" (pendientes de reubicar) */}
      {reuActual &&
        reuActual.ubicacionesREUEmpleadoLogeado
          ?.filter((item) => item.estado === "2")
          .map((item, index) => {
            const key = `${item.idomau}-${index}`; // más seguro que SKU (puede ser null)

            const handleEdit = () => {
              setModalVisible({
                status: true,
                payload: {
                  ...item,
                  ...reuActual,
                  sku: item.sku,
                  nombre: item.nombre,
                  modelo: item.modelo,
                  ubicacion: item.idubid,
                  cantidad: null,
                  valorInicial: item.confir,
                },
              });
            };

            return (
              <Col span={24} key={key} style={{ display: "flex" }}>
                {item.idpale ? (
                  <PaletCard
                    item={item}
                    darkMode={darkMode}
                    ordenActiva={ordenActiva}
                    reuActual={reuActual}
                    onEdit={handleEdit}
                    onLongPressUnlock={handleLongPressUnlock}
                  />
                ) : (
                  <ArticuloCard
                    item={item}
                    darkMode={darkMode}
                    ordenActiva={ordenActiva}
                    reuActual={reuActual}
                    onEdit={handleEdit}
                  />
                )}
              </Col>
            );
          })}

      {/* Artículos ya reubicados (estado "3"), agrupados por SKU */}
      {reuActual && hayReubicados && (
        <Col span={24} style={{ display: "flex" }}>
          <Collapse
            style={{ width: "100%" }}
            styles={{
              content: { padding: 8 },
            }}
            size="large"
            items={Object.entries(
              (reuActual.ubicacionesREUEmpleadoLogeado || [])
                .filter((item) => item.estado === "3")
                .reduce((acc, item) => {
                  // Agrupar por SKU si existe, sino por idpale (para palets)
                  const key =
                    item.sku || item.idpale || `fallback-${item.idomau}`;
                  if (!acc[key]) acc[key] = [];
                  acc[key].push(item);
                  return acc;
                }, {}),
            ).map(([key, items]) => {
              // Determinar el nombre a mostrar: SKU si existe, sino idpale
              const displayLabel =
                items[0]?.sku || `#${items[0]?.idpale}` || "ntificador";

              return {
                key,
                label: `${displayLabel} (${items.length} movimientos)`,
                children: (
                  <Row gutter={[8, 8]}>
                    {items.map((item, idx) => (
                      <Col key={`${item.idomau}-${idx}`} span={24}>
                        {item.idpale ? (
                          <PaletCard
                            item={item}
                            darkMode={darkMode}
                            ordenActiva={ordenActiva}
                            reuActual={reuActual}
                            onEdit={null}
                            onLongPressUnlock={null}
                          />
                        ) : (
                          <ArticuloCard item={item} darkMode={darkMode} />
                        )}
                      </Col>
                    ))}
                  </Row>
                ),
              };
            })}
          />
        </Col>
      )}

      {ordenActiva && (
        <>
          <Divider style={{ margin: 6 }} />
          <Col span={24}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 8,
                marginBottom: 8,
              }}
            >
              {reuActual?.accion === "1" && (
                <Button
                  block
                  disabled={loading}
                  variant="outlined"
                  size="large"
                  onClick={handlePasarAIngreso}
                >
                  Pasar a Ingreso
                </Button>
              )}
              {reuActual?.accion === "2" && (
                <Button
                  block
                  disabled={loading}
                  size="large"
                  variant="outlined"
                  onClick={handlePasarAEgreso}
                >
                  Pasar a Egreso
                </Button>
              )}
            </div>

            {(hayReubicados || hayPendientesDeConfirmar) && (
              <Popconfirm
                title="Confirmar acción"
                onConfirm={async () => {
                  const res = await PUTCompletarOma(
                    reuActual?.idOpe,
                    hayPendientesDeConfirmar,
                  );

                  if (res?.status === 200) {
                    // message.success(res.data?.descri || "OK");
                    navigate(-1);
                  } else {
                    message.error(res?.data?.message || "Se produjo un error.");
                  }
                }}
                okText="Sí"
                cancelText="No"
              >
                <Button type="primary" size="large" block disabled={loading}>
                  Finalizar reubicación
                </Button>
              </Popconfirm>
            )}
          </Col>
        </>
      )}

      {modalVisible?.status && (
        <Suspense fallback={null}>
          <ModalTecladoCantidad
            darkMode={darkMode}
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            onConfirm={handleConfirmModal}
          />
        </Suspense>
      )}

      {/* Modal de desbloqueo de palet */}
      {unlockModal.visible && (
        <Suspense fallback={null}>
          <Modal
            title="Abrir palet"
            open={unlockModal.visible}
            onOk={handleConfirmUnlock}
            onCancel={handleCancelUnlock}
            okText="Sí, abrir"
            cancelText="Cancelar"
            centered
            maskClosable={false}
          >
            {unlockModal.palet && (
              <>
                <p>
                  ¿Estás seguro de que deseas <strong>abrir</strong> el palet{" "}
                  <strong>#{unlockModal.palet.idpale}</strong>?
                </p>
                <p>
                  Esta acción es <strong>irreversible</strong>.
                </p>
              </>
            )}
          </Modal>
        </Suspense>
      )}

      <ModalStockVLX
        open={modalStockVLX.open}
        items={modalStockVLX.items}
        onSelect={confirmarItemStockVLX}
        onClose={() =>
          setModalStockVLX({
            open: false,
            items: [],
            codigoOriginal: null,
            responseCodigo: null,
          })
        }
      />
    </>
  );
};

export default RenderREU;
